<template>
  <div class="create-group">
    <div v-if="selectedGroup.id" class="create-group__title">
      Edit Group
    </div>
    <div v-else class="create-group__title">
      Create New Group
    </div>
    <label v-if="selectedGroup.id" class="create-group__input">
      <span class="create-group__label">Active</span>
      <div class="create-group__link-wrapper" :class="{'create-group__link-wrapper_single': isDomainDropdownHidden}">
        <base-select v-model="group.is_active" class="create-group__active" :disabled="disableButtons"
          :options="activeOpts" :max-height-list="450" :title-style="titleStyle" :header-style="selectTypeStyle" />
      </div>
    </label>
    <label class="create-group__input">
      <span class="create-group__label">Category</span>
      <div class="create-group__link-wrapper" :class="{'create-group__link-wrapper_single': isDomainDropdownHidden}">
        <base-select v-model="group.category_id" class="create-group__active" :disabled="disableButtons"
          :options="categories" :max-height-list="450" :title-style="titleStyle" :header-style="selectTypeStyle" />
      </div>
    </label>
    <label class="create-group__input">
      <span class="create-group__label">Name</span>
      <div class="create-group__link-wrapper" :class="{'create-group__link-wrapper_single': isDomainDropdownHidden}">
        <input v-model="group.name" type="text" :disabled="disableButtons" class="form-control create-group__link-field"
          placeholder="Enter the Name for this group" :class="{'form-control_error': externalErrors.name}">
        <span v-if="externalErrors.name" class="create-group__error-message">{{ externalErrors.name }}</span>
      </div>
    </label>
    <label class="create-group__input">
      <span class="create-group__label">Description</span>
      <div class="form-control description__wrapper" :class="{'description__wrapper_disabled': disableButtons}">
        <textarea v-model="group.description" class="description" :disabled="disableButtons" rows="6"
          placeholder="Enter Description" />
      </div>
    </label>
    <span class="create-group__label create-group__input">Associated Users</span>
    <base-check-box v-for="(user, i) in usersList" :key="i" v-model="user.selected" class="create-group__checkbox"
      :label="user.name" :should-gray-unselected="false" @change="updateSelectedUsers" />
    <div class="create-group__controls">
      <button class="create-group__button create-group__button_cancel"
        :class="{'create-section__button_disabled': disableButtons}" @click.prevent="close()">
        Cancel
      </button>
      <button v-if="selectedGroup.id" class="create-group__button create-group__button_delete"
        :class="{'create-section__button_disabled': disableButtons}" @click.prevent="openConfirmModal()">
        Delete
      </button>
      <button class="create-group__button create-group__button_submit"
        :class="{'create-section__button_disabled': disableButtons}" @click.prevent="apply()">
        Apply
      </button>
    </div>
    <modal name="confirm-modal" v-bind="modalProps">
      <base-confirm-modal title="Are you sure you want to delete this?"
        subtitle="This Group will be removed permanently!" @confirm="confirmModal" />
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
]
export default {
  name: 'GroupsCrud',
  mixins: [BaseModalMixins],
  props: {
    selectedGroup: {
      type: Object,
      required: false,
      default() {
        return {
          id: null,
          is_active: null,
          category_id: null,
          name: null,
          description: null,
          users: []
        }
      }
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      group: _.cloneDeep(this.selectedGroup),
      externalErrors: {
        name: null,
        fk_pivot_table: null
      },
      disableButtons: false,
      isValidating: false,
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      activeOpts: _.cloneDeep(ACTIVE_OPTIONS),
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  computed: {
    ...mapState('users', ['users']),
    modalProps() {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    usersList() {
      return this.users.map(user => {
        user.selected = this.group.users.includes(user._id)
        return user
      })
    }
  },
  methods: {
    updateSelectedUsers() {
      this.group.users = this.usersList.filter(user => user.selected).map(user => user._id)
    },
    close() {
      this.$emit('close')
    },
    openConfirmModal() {
      this.$modal.show('confirm-modal')
    },
    confirmModal(status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        this.deleteGroup()
      }
    },
    convertToOptions(item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors(errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    deleteGroup() {
      this.$emit('delete', this.group.id)
    },
    async apply() {
      this.disableButtons = true
      const trimFields = ['name', 'description']
      const group = { ...this.group }
      trimFields.forEach(v => {
        group[v] = group[v] ? group[v].trim() : null
      })
      this.disableButtons = false
      if (!group.id) {
        this.$emit('create', group)
      } else {
        this.$emit('update', group)
      }
    }
  }
}
</script>

<style lang="scss">
.create-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;

  &__checkbox {
    margin-top: 10px;
  }

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin: 9px 0 35px;
    color: $rfx-dark-march;
  }

  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;

    &_invalid[type='text'] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;

      &:disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.4;
      cursor: default;
    }

    &_delete {
      background-color: $rfx-red;
      color: #fff
    }

    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }

  &__link {
    &-wrapper {
      position: relative;
      margin-top: 30px;

      &_single {
        margin-top: 0;
      }
    }

    &-field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      font-weight: 500;
      @include ellipsis;
    }
  }

  &__error-message {
    color: $rfx-red;
    font-size: 10px;
    margin-top: 5px;
  }

}

.form-control {
  height: 50px;
  padding: 0 20px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

.description {
  width: 100%;
  height: 90%;
  padding: 0;
  resize: none;
  outline: none;
  border: none;
  font-size: 14px;

  &:disabled {
    background-color: transparent;
  }

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
    margin-top: -5px;
  }

  &__wrapper {
    padding: 10px 20px;
    height: auto;

    &_disabled {
      background-color: #fafafa;
    }
  }
}
</style>
